import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"
import { calculateTotalPriceDisplay } from "src/main/Contracts/ContractsForm/tabPanels/AddItems/utils"

import Tooltip from "src/components/Tooltip"

import { queryProductDetails } from "src/api/Billing/Items"

const PriceInformation = ({
  field,
  useNewTaxExperience,
  isGroup,
  marinaSlug,
  currencySymbol,
}) => {
  const {
    data: product,
    isLoading,
    isFetching,
    isError,
  } = useQuery(
    ["productDetails", field.productId, marinaSlug],
    () => queryProductDetails({ productId: field.productId, marinaSlug }),
    {
      enabled: useNewTaxExperience && isGroup && !!field.productId,
      refetchOnWindowFocus: false,
    }
  )

  if (useNewTaxExperience && isGroup) {
    if (isLoading || isFetching) {
      return (
        <div className="text-center">
          <i className="fa-kit fa-spinner animate-spin" />
        </div>
      )
    } else if (isError) {
      return (
        <Tooltip
          variant="dark"
          maxWidth="275px"
          text="There was an error getting price information, if the problem persists please contact mayday@dockwa.com."
          placement="top"
        >
          <div className="text-center">
            <i className="fa-kit fa-exclamation-circle text-red-700" />
          </div>
        </Tooltip>
      )
    } else if (product) {
      if (!field.itemizedTaxData) {
        // Transform the tax data to match the expected format (camelCase)
        field.itemizedTaxData = product.taxes?.map((tax) => ({
          ...tax,
          rateDisplay: tax.rate_display || tax.rateDisplay,
        }))
      }

      return calculateTotalPriceDisplay(field, currencySymbol)
    }
  }

  return calculateTotalPriceDisplay(field, currencySymbol)
}

PriceInformation.propTypes = {
  field: PropTypes.object.isRequired,
  useNewTaxExperience: PropTypes.bool.isRequired,
  isGroup: PropTypes.bool.isRequired,
  marinaSlug: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
}

export default PriceInformation
